export const environment = {
  graphqlApiUrl: 'https://75s7lctypfbvhg47mdrvuf7euu.appsync-api.eu-central-1.amazonaws.com/graphql',
  cognito: {
    userPoolId: 'eu-central-1_x6TvJyrhl',
    userPoolWebClientId: '5bkueo510ets77bgoeu65cfu8v',
  },
  maps: {
    apiKey:
      'v1.public.eyJqdGkiOiJmMzMxMzI5OS1lYWI2LTQ2YjQtYjFlMy00MDI3OTNlZDNjOGYifXvQX8RhyClE4grq8WnvHcWIEpHabynVfXgH7avoAwQx2Vxa6mlML3YXxAkcaehxqupmpnAHuuM_GgerySgk5-2B1wzFG5Mf_KFZcPEVUv1ZPUQ8FeCEYaw3Cv58eFZJPvwm7ywu71wZCdGdCGk_pmpTtpBA9yOPIzpxoA9rMXu_35kF-yGhh5WwjTctPFD79FHQTb-56oZOT_wJDRL1bzmDcO-UaZYIILSKhlQ4EXd1bArxywFqAhc0r1RhIbCQUNJ8zp6_iFqdATZeoXSIdUFduqsLCFxVG7_Tv2NGtpUVjHgXfOMvkkQgQ-wXFhOZiTebaDKCrZDdaidyo7QHMQM.Y2MzMTcwNWYtZTgwMy00NGZlLWFiNGItNzVkMDFmMDM0Nzcy',
    mapName: 'MapServiceFrontend',
    region: 'eu-central-1',
    indexName: 'FrontendPlaceIndex',
  },
};
